import React, { useContext, useState} from "react";
import Config from "../../../../config/main";
import CasinoGamesList from "./gamesList";
import { FavoritesContext } from "../../../../contexts/favorites";


const CasinoFavorites = () => {
    const [{ casino: favorite }] = useContext(FavoritesContext);
    const [offset, setOffset] = useState(0)
    const limit = Config.casino.games.loaderStep

    const pagination = (newOffset) => {
        if (newOffset < offset && offset === 0) return
        else if (newOffset >= Object.values(favorite).length) return

        setOffset(newOffset)
    }

    return <>
        <div className="casino-wrapper">
            <div className="casino-games-list-view">
                <div className="single-game-type-list">
                    <CasinoGamesList games={Object.values(favorite)?.slice(offset, offset + limit)} />
                </div>
                <div className="slider-arrow-t">
                    <div className="left-arrow-t" onClick={() => pagination(offset - limit)}>
                        <i className="icon-s-t" />
                    </div>
                    <div className="right-arrow-t" onClick={() => pagination(offset + limit)}>
                        <i className="icon-s-t" />
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default CasinoFavorites;